import { render, staticRenderFns } from "./UpdatedDatetime.vue?vue&type=template&id=1c0d9525&scoped=true&"
import script from "./UpdatedDatetime.vue?vue&type=script&lang=js&"
export * from "./UpdatedDatetime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0d9525",
  null
  
)

export default component.exports